import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import cancelIcon from '@lifesize/ux-assets/vectors/svgIcons/cancel.svg';
import ButtonComp from 'components/Button/Button';
import ContactCardHeader from 'components/Contacts/ContactCardHeader';
import Tooltip from 'components/Tooltip/Tooltip';
import ContactDetails from 'containers/Contacts/ContactDetails';
import classes from './ContactCard.module.scss';

const messages = defineMessages({
  cannotEdit: {
    id: 'components.contactCard.cannotEdit',
    defaultMessage: 'You cannot edit an active meeting'
  },
  cannotDelete: {
    id: 'components.contactCard.cannotDelete',
    defaultMessage: 'You cannot delete an active meeting'
  }
});

class ContactCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      scroll: 0
    };
  }

  onCloseCard = (event) => {
    event.stopPropagation();
    this.props.unselectContact();
  };

  onDelete = (event) => {
    event.stopPropagation();
    this.props.handleDelete(this.props.contact);
  };

  onEdit = (event) => {
    event.stopPropagation();
    this.props.handleEdit(this.props.contact);
  };

  render() {
    const { contact } = this.props;
  
    const editButton = (<FormattedMessage
      id="edit"
      defaultMessage="Edit"
    />);

    const deleteButton = (<FormattedMessage
      id="delete"
      defaultMessage="Delete"
    />);

    const showCrudButtons = Boolean(contact.isPersonalContact ||
      contact.ownerID === this.props.currentUserId);
    
    const disableDeleteButton = (
      contact.isMeeting &&
      contact.participantsCount > 0
    );

    let CrudButtons;
    if (showCrudButtons) {
      CrudButtons = (<div className={classes.crudButtonContainer}>
        <ButtonComp
          kind="secondary"
          style={{ width: 145, minWidth: 145 }}
          onClick={this.onEdit}
          disabled={!!this.props.contact.participantsCount}
          dataAttrs={{ 'data-testid': 'card-edit-btn' }}
        >
          {editButton}
          {!!this.props.contact.participantsCount &&
            <Tooltip
              style={{ width: '145px', whiteSpace: 'normal', marginBottom: '10px' }}
              location="top"
              label={this.props.intl.formatMessage(messages.cannotEdit)}
            />}
        </ButtonComp>
        <ButtonComp
          kind="primary"
          style={{ width: 145, minWidth: 145 }}
          onClick={this.onDelete}
          disabled={disableDeleteButton}
          dataAttrs={{ 'data-testid': 'card-delete-btn' }}
        >
          {deleteButton}
          {disableDeleteButton &&
            <Tooltip
              style={{ width: '145px', whiteSpace: 'normal', marginBottom: '10px' }}
              location="top"
              label={this.props.intl.formatMessage(messages.cannotDelete)}
            />}
        </ButtonComp>
      </div>);
    }

    return (
      <div className={classes.container}>
        <div
          className={classes.scrollArea}
        >
          <ContactCardHeader
            contact={contact}
            handleAudioCall={this.props.handleAudioCall}
            handleChat={this.props.handleChat}
            handleRemoteModerate={this.props.handleRemoteModerate}
            handleSchedule={this.props.handleSchedule}
            handleVideoCall={this.props.handleVideoCall}
            isChatEnabled={this.props.isChatEnabled}
            remoteModerationIsActive={this.props.remoteModerationIsActive}
            remoteModerationIsActiveForThisMeeting={!!this.props.remoteModerationIsActiveForThisMeeting}
            scroll={this.state.scroll}
            userCanRemoteModerate={this.props.userCanRemoteModerate}
          />
          <ContactDetails contact={contact} showCrudButtons={showCrudButtons} />
        </div>
        <button className={classes.closeButton} onClick={this.onCloseCard} data-testid="cancelButton" >
          <SVG src={cancelIcon} data-testid="cancelIcon" />
        </button>
        {CrudButtons}
      </div>
    );
  }
}

ContactCard.propTypes = {
  contact: PT.object.isRequired,
  currentUserId: PT.string,
  handleAudioCall: PT.func.isRequired,
  handleChat: PT.func,
  handleDelete: PT.func,
  handleEdit: PT.func,
  handleRemoteModerate: PT.func,
  handleSchedule: PT.func,
  handleVideoCall: PT.func.isRequired,
  intl: PT.object,
  isChatEnabled: PT.bool,
  remoteModerationIsActive: PT.bool,
  remoteModerationIsActiveForThisMeeting: PT.bool,
  unselectContact: PT.func.isRequired,
  userCanRemoteModerate: PT.bool
};

export default injectIntl(ContactCard);
